import univSchoolMedical from "../assets/HomePage/UniversityPrograms/univ-school-medical.png";
import univSchoolBusiness from "../assets/HomePage/UniversityPrograms/univ-school-business.png";
import univSchoolLanguage from "../assets/HomePage/UniversityPrograms/univ-school-language.png";
import univSchoolTechnology from "../assets/HomePage/UniversityPrograms/univ-school-technology.png";
import univSchoolArch from "../assets/HomePage/UniversityPrograms/univ-school-arch.png";
import univSchoolLaw from "../assets/HomePage/UniversityPrograms/univ-school-law.png";

export const universityProgramsTabs = [
  { id: "bachelor", name: "Bachelor" },
  { id: "masters", name: "Masters" },
  { id: "doctorate", name: "Ph.D/Doctorate" },
  { id: "courses", name: "Short courses" },
];

export const universityProgramsBachelor = [
  {
    name: "SCHOOL OF GENERAL MEDICAL",
    path: "#",
    img: univSchoolMedical,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 7",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 8",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 9",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 10",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 11",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 12",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Business MENEDGMENT",
    path: "#",
    img: univSchoolBusiness,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 2-1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-6",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-7",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-8",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-9",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-10",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Language School",
    path: "#",
    img: univSchoolLanguage,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Information technology",
    path: "#",
    img: univSchoolTechnology,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "School of Architecture & Engineering",
    path: "#",
    img: univSchoolArch,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "School of Law",
    path: "#",
    img: univSchoolLaw,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
];

export const universityProgramsMasters = [
  {
    name: "SCHOOL OF GENERAL MEDICAL Masters",
    path: "#",
    img: univSchoolMedical,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Business MENEDGMENT Masters",
    path: "#",
    img: univSchoolBusiness,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 2-1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-6",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Language School Masters",
    path: "#",
    img: univSchoolLanguage,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Information technology Masters",
    path: "#",
    img: univSchoolTechnology,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "School of Architecture & Engineering Masters",
    path: "#",
    img: univSchoolArch,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "School of Law Masters",
    path: "#",
    img: univSchoolLaw,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
];

export const universityProgramsDoctorate = [
  {
    name: "SCHOOL OF GENERAL MEDICAL Doctorate",
    path: "#",
    img: univSchoolMedical,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Business MENEDGMENT Doctorate",
    path: "#",
    img: univSchoolBusiness,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 2-1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-6",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Language School Doctorate",
    path: "#",
    img: univSchoolLanguage,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Information technology Doctorate",
    path: "#",
    img: univSchoolTechnology,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "School of Architecture & Engineering Doctorate",
    path: "#",
    img: univSchoolArch,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "School of Law Doctorate",
    path: "#",
    img: univSchoolLaw,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
];

export const universityProgramsCourses = [
  {
    name: "SCHOOL OF GENERAL MEDICAL Courses",
    path: "#",
    img: univSchoolMedical,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Business MENEDGMENT Courses",
    path: "#",
    img: univSchoolBusiness,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 2-1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2-6",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Language School Courses",
    path: "#",
    img: univSchoolLanguage,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "SCHOOL OF Information technology Courses",
    path: "#",
    img: univSchoolTechnology,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "School of Architecture & Engineering Courses",
    path: "#",
    img: univSchoolArch,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
  {
    name: "School of Law Doctorate",
    path: "#",
    img: univSchoolLaw,
    programs: [
      {
        name: "Anesthesiology, resuscitation and intensive care 1",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 2",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 3",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 4",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 5",
        path: "#",
      },
      {
        name: "Anesthesiology, resuscitation and intensive care 6",
        path: "#",
      },
    ],
  },
];
